import { Button, ButtonSize, ButtonVariant, IconVariants } from "@next-platform/client-common-spicy-ui";

interface GenerateSuggestedFieldButtonProps {
  field: string;
  onButtonClick: () => Promise<void>;
  disabled?: boolean;
  isLoading?: boolean;
  label?: string;
}

const GenerateSuggestedFieldButton = ({
  field,
  onButtonClick,
  disabled = false,
  isLoading = false,
  label = "",
}: GenerateSuggestedFieldButtonProps) => {
  return (
    <Button
      onClick={onButtonClick}
      disabled={isLoading || disabled}
      data-testid={`generate-${field}-button`}
      size={ButtonSize.SMALL}
      variant={ButtonVariant.SECONDARY}
      loading={isLoading}
      iconStart={!isLoading ? IconVariants.SPARKLES : undefined}
    >
      {label}
    </Button>
  );
};

export default GenerateSuggestedFieldButton;
